import { render, staticRenderFns } from "./OverviewCards.vue?vue&type=template&id=52afe7b4&scoped=true"
import script from "./OverviewCards.vue?vue&type=script&lang=js"
export * from "./OverviewCards.vue?vue&type=script&lang=js"
import style0 from "./OverviewCards.vue?vue&type=style&index=0&id=52afe7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afe7b4",
  null
  
)

export default component.exports